import * as yup from "yup";
export const TaskAddSchema = yup.object().shape({
  name: yup.string(),
  description: yup.string(),
  user_id: yup.string(),
  due_date: yup.string().required("Required *"),
});
export const TaskInitialValues = {
  name: "",
  description: "",
  user_id: "",
  due_date: "",
};
